<app-static-page-layout pageTitle="Privacy Policy">
  <div class="privacy-content">
    <!-- Logo Section -->
    <section class="logo-section">
      <div class="ciranet-logo">
        <app-icon
          name="ciranet-logo"
          size="100%"
          ariaLabel="CiraNet Logo"
        ></app-icon>
      </div>
      <div class="realmanage-logo">
        <app-icon
          name="realmanage-logo"
          size="100%"
          ariaLabel="RealManage Logo"
        ></app-icon>
      </div>
    </section>

    <!-- Privacy Policy Content -->
    <section class="policy-content">
      <h2>Privacy Policy</h2>

      <article class="policy-section">
        <p>
          We respect the privacy and security of your personally identifiable
          information that we collect about you online. The following describes
          our privacy policy and practices with respect to that information. By
          your registration to use, or use of the services, you consent to our
          collection and use of your personally identifiable information and
          other information online by us in the manner set forth in this Online
          Privacy Policy. Please read this policy carefully. We may change this
          policy from time to time, and we will post those changes on this page.
          Please check back periodically.
        </p>
      </article>

      <article class="policy-section">
        <p>
          If you have any questions concerning our Online Privacy Policy, please
          contact us via email at
          <a href="mailto:service@ciramail.com" class="email-link">
            service&#64;ciramail.com
          </a>
          .
        </p>
      </article>

      <article class="policy-section">
        <p>
          Your community association or its management company may give us
          personally identifiable information about you to permit us to verify
          your identity as a person who is entitled to register to use and to
          continue to use the services we provide to you and your community
          association through your community association's management company.
          When you register to use services, we will ask for certain personally
          identifiable information to confirm your identity as a person
          authorized to use the services. This information is required to be
          complete and accurate at the time it is given, and to be updated so
          that it is at all times accurate and complete, as a condition of your
          continued ability to use the services.
        </p>
      </article>

      <article class="policy-section">
        <p>
          Once you have registered to use the services, whenever you sign in to
          use the services your personal identity is known to us.
        </p>
      </article>

      <article class="policy-section">
        <p>
          Other personally identifiable information about you may be given to us
          by the community association, its management company, or you in order
          to render the services. For example, we may assist the community
          association's management company in compiling an electronic database
          of members of the community association, or posting an online
          directory of members.
        </p>
      </article>

      <article class="policy-section">
        <p>
          You may give your credit card number to the community association or
          its management company or us through the services in order to pay your
          community association's dues or assessments or to pay for other items.
          However, prior to its transmission to your community association's (or
          its management company's) bank, your credit card information is
          encrypted through the use of secure server software and is then
          transmitted in this secure and encrypted fashion. Your credit card
          information is not retained by us.
        </p>
      </article>

      <article class="policy-section">
        <p>
          If you send an email message, we will receive your email address and
          any other personally identifiable information you may include in that
          message.
        </p>
      </article>

      <article class="policy-section">
        <p>
          When users or other visitors visit a web site that we manage or when
          they access or utilize one of our mobile applications, our servers
          automatically record certain information and retain it in the servers'
          logs. This information may include your type of device, operating
          system, IP address, domain name, browser type, GPS location, date and
          time of the visit, pages or modules visited and the duration spent on
          each page, and similar information that is not normally considered
          "personally identifiable information". The information may also
          include logging any actions taken by you on those web sites or via our
          mobile applications; including the date and time such action was
          taken. These actions may include, for example, entering data into an
          online form or submitting your approval or denial to an item or
          question.
        </p>
      </article>

      <article class="policy-section">
        <p>
          In the course of using the services, you may provide personally
          identifiable information to others. For example, you might post a
          message to a message board, submit an online form, or send an email to
          another member, your community association, or the community
          association's management company, that may contain personally
          identifiable information. We do not control the privacy practices or
          policies of any such person or entity, and they are not covered by
          this Online Privacy Policy.
        </p>
      </article>

      <article class="policy-section">
        <p>
          We do not sell or rent your personally identifiable information in the
          normal course of our business; however, if all or substantially all of
          our assets are sold to a third party, your personally identifiable
          information will be included in the assets transferred. We share your
          personally identifiable information with your community association
          and the community association's management company, on whose behalf we
          are providing the services. We also share the information with third
          parties that may provide a portion of the services. We do not allow
          such third parties to use that information other than in connection
          with the provisions of the services. We may disclose personally
          identifiable information to any third party if required to do so by
          law or regulation, or if we believe in good faith that such disclosure
          is necessary to:
        </p>
        <ol class="alpha-list">
          <li>comply with legal process;</li>
          <li>enforce the Terms of Service;</li>
          <li>
            respond to claims that any content of any portion of the services
            violated the rights of third parties; or
          </li>
          <li>
            protect the rights, property, or personal safety of us, other Users
            or the public.
          </li>
        </ol>
      </article>

      <article class="policy-section">
        <p>
          We may maintain our own separate databases in order to provide the
          services, to which you will not have online access. For example, we
          may maintain one or more databases of members of a community
          association who are entitled to become and remain users of the
          services. Such databases may contain information furnished by the
          community association, its management company, and/or members, or
          otherwise collected as set forth in this Online Privacy Policy. If you
          wish to ask us about the personally identifiable information that we
          may have collected about you and that is not available to you online,
          you should email us at
          <a href="mailto:service@ciramail.com" class="email-link">
            service&#64;ciramail.com
          </a>
          . We will use commercially reasonable efforts to comply with your
          request, and to update and/or correct any personally identifiable
          information that is contained within such databases.
        </p>
      </article>

      <article class="policy-section">
        <p>
          Access to the services, including to databases containing personally
          identifiable information, is password protected. Any personal
          information that you have posted in any portion of the services (e.g.
          a message board or an online form) should be accessible only by the
          community association, the community association's management company,
          other members and other authorized users of the services. It is the
          responsibility of each user to protect the user's password. Do not
          divulge it to anyone. Log off your computer or close your browser
          window to ensure that others cannot access your password.
        </p>
      </article>

      <article class="policy-section">
        <p>
          We use industry-standard software, hardware and other measures, to
          protect the confidentiality, security and quality of information we
          collect, and to protect it from unauthorized access or disclosure or
          accidental loss, alteration or destruction. Due to the nature of the
          Internet and computer security, we cannot warrant or guarantee that
          security will never be breached. If any personally identifiable
          information is breached you agree to hold us harmless for any damages
          or agree that we will have no obligation to monitor your information
          in the future for use by unauthorized parties.
        </p>
      </article>

      <article class="policy-section">
        <p>
          You must be 18 years of age or older to register to use the services.
          We do not knowingly collect personally identifiable information from
          children under the age of 13. If such information is inadvertently or
          unknowingly collected, it is our policy to destroy or delete it upon
          discovery.
        </p>
      </article>

      <article class="policy-section">
        <h3>Google API Services</h3>
        <p>
          CiraNet's use and transfer to any other app of information received
          from Google APIs will adhere to the
          <a
            href="https://developers.google.com/terms/api-services-user-data-policy"
            target="_blank"
            rel="noopener noreferrer"
            class="external-link"
          >
            Google API Services User Data Policy
          </a>
          , including the Limited Use requirements. We only access your Google
          name and email to authenticate your account.
        </p>
      </article>
    </section>
  </div>
</app-static-page-layout>
